<!-- <div>
  <h1>ControlFMS Customer Portal</h1>
  <button (click)="requestTest()">Test</button>
  <pre>{{testData | json}}</pre>
</div> -->

<app-loader></app-loader>
<router-outlet></router-outlet>
